import { createRoot } from 'react-dom/client';
import ScrollToTop from './components/ScrollToTop';
// import reportWebVitals from './reportWebVitals';
import './App.css';
import './css/oldCss.css'

import {
  BrowserRouter,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

// import Blizzard from './components/Blizzard';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Career from './pages/Career';
import Stats from './pages/Stats';
import PersonalHistory from './pages/PersonalHistory';

function App() {
  const location = useLocation();

  return (
    <>
    <Header />
    <div
      id="siteContent"
      style={{
        // position: 'fixed',
        position: 'relative',
        padding: '0 20px'
        // top: '150px',
        // left: '0px',
        // width: '100vw',
        // height: 'calc(100vh - 150px)',
        // overflow: 'auto',
        // zIndex: '1',
        // MaskImage: 'linear-gradient(transparent 0%, black 5%, black 95%, transparent 100%)',
        // WebkitMaskImage: 'linear-gradient(transparent 0%, black 5%, black 95%, transparent 100%)'
      }}
    >
      <TransitionGroup component={null}>
        <CSSTransition key={location.key} classNames="fade" timeout={300}>
          <ScrollToTop>
            <Routes location={location}>
              <Route path="/career" element={<Career />} />
              <Route path="/stats" element={<Stats />} />
              <Route path="/personalhistory" element={<PersonalHistory />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </ScrollToTop>
        </CSSTransition>
      </TransitionGroup>
    </div>
    <Footer />
    </>
  );
}

// Placed the context provider here so that <App/> can call useLocation()
const Root = () => <BrowserRouter><App /></BrowserRouter>;

const root = createRoot(document.getElementById('root'));
root.render(<Root />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
